/* Clignote : 2e paire dans le panier, date de livraison estimée, fenêtre e-mail */
(() => {
  const C = window.Clignote, P = window.ClignotePlus;
  if (!C || !P) return;
  const $ = (s, r = document) => r.querySelector(s);
  const money = cents => (C.formatMoney ? C.formatMoney(cents) : (cents / 100).toLocaleString(P.locale, { style: 'currency', currency: P.currency }));
  const esc = s => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const lire = k => { try { return localStorage.getItem(k); } catch (e) { return null; } };
  const ecrire = (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} };

  /* ---------- « Et une 2e paire ? » dans le panier ---------- */
  // L'option pack est celle dont les valeurs commencent par un chiffre (1 paire, 2 paires...), sinon la 2e option.
  const packPos = p => { const i = p.options.findIndex(o => o.values.every(v => /^\d/.test(v))); return i >= 0 ? i : (p.options.length > 1 ? 1 : 0); };
  const produits = {};
  const produit = h => produits[h] || (produits[h] = fetch(C.routes.root.replace(/\/$/, '') + '/products/' + h + '.js').then(r => r.json()));

  async function proposer() {
    const zone = $('#cart-drawer .items'); if (!zone) return;
    $('#cart-drawer .upsell')?.remove();
    const cart = await fetch(C.routes.cart + '.js').then(r => r.json());
    for (const [i, it] of cart.items.entries()) {
      if (it.quantity !== 1) continue;
      const p = await produit(it.handle).catch(() => null);
      if (!p || p.variants.length < 2) continue;
      const pos = packPos(p), v = p.variants.find(x => x.id === it.variant_id);
      if (!v || v.options[pos] !== p.options[pos].values[0]) continue;
      const duo = p.variants.find(x => x.available && x.options[pos] === p.options[pos].values[1] && x.options.every((o, k) => k === pos || o === v.options[k]));
      if (!duo) continue;
      const html = `<div class="upsell"><div><b>${esc(P.t.up_title)}</b><small>${esc(P.t.up_text.replace('{prix}', money(duo.price - v.price)).replace('{total}', money(duo.price)))}</small></div>
        <button type="button" class="btn-ghost" data-upsell="${i + 1}" data-duo="${duo.id}">${esc(P.t.up_button)}</button></div>`;
      zone.insertAdjacentHTML('afterend', html);
      return;
    }
  }
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-upsell]'); if (!b) return;
    b.disabled = true;
    await fetch(C.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +b.dataset.upsell, quantity: 0 }) });
    await fetch(C.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.duo, quantity: 1 }] }) });
    C.refreshCart && C.refreshCart();
  });
  const items = $('#cart-drawer .items');
  if (items) { let t; new MutationObserver(() => { clearTimeout(t); t = setTimeout(proposer, 150); }).observe(items, { childList: true }); proposer(); }

  /* ---------- Date de livraison estimée ---------- */
  function plusJoursOuvres(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; }
  document.querySelectorAll('[data-eta]').forEach(el => {
    const f = new Intl.DateTimeFormat(P.locale, { weekday: 'short', day: 'numeric', month: 'short' });
    const a = plusJoursOuvres(new Date(), +el.dataset.min || 3), b = plusJoursOuvres(new Date(), +el.dataset.max || 8);
    el.textContent = P.t.eta.replace('{a}', f.format(a)).replace('{b}', f.format(b));
    el.hidden = false;
  });

  /* ---------- Fenêtre e-mail −10 % ---------- */
  const nl = $('#nl-popup');
  if (nl) {
    const ouvrir = () => { nl.hidden = false; document.body.classList.add('nl-open'); $('input[type=email]', nl)?.focus(); };
    const fermer = () => { nl.hidden = true; document.body.classList.remove('nl-open'); ecrire('clignote-nl', 'vu'); };
    nl.addEventListener('click', e => { if (e.target === nl || e.target.closest('[data-nl-close]')) fermer(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !nl.hidden) fermer(); });
    if ($('[data-nl-done]', nl) || location.search.includes('customer_posted=true')) { ouvrir(); ecrire('clignote-nl', 'inscrit'); }
    else if (!lire('clignote-nl')) {
      // Jamais par-dessus le panier : on attend qu'il soit fermé.
      const essayer = () => document.querySelector('#cart-drawer.open') ? setTimeout(essayer, 10000) : ouvrir();
      setTimeout(essayer, 15000);
    }
  }
})();
